"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeSchema = void 0;
var zod_1 = require("zod");
exports.BadgeSchema = zod_1.z.object({
    text: zod_1.z.string().nullish(),
    type: zod_1.z
        .enum(['THUMBNAIL_PRIMARY', 'THUMBNAIL_MEMBER_CLASS_GOLD', 'BENEFIT_PRIMARY', 'BENEFIT_INFO', 'BENEFIT_ACCENT'])
        .nullish(),
});
